@if(shouldShow()) {
  <div class="app-banner" [ngClass]="getBannerClass()">
    <div class="sys-stats">
      <h3>Env: <b>{{environmentName()}}</b></h3>
      <span class="app-network-status" [class.app-network-status--offline]="!isOnline()" title="{{ isOnline() ? 'Network connected' : 'No network connection' }}">
        <fa-icon icon="wifi"></fa-icon>
        @if (!isOnline()) {
          <fa-icon class="app-network-status-ban" icon="ban"></fa-icon>
        }
      </span>
    </div>
    <p>{{tenantName()}}</p>
  </div>
}